import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

@Injectable({
    providedIn: 'root'
})
export class InventoryDetailsPopupService {

    private modal: Modal | null = null;

    constructor(private router: Router) {
    }

    open(gid: any, initialTab: string = 'lot') {
        // Navigate to the modal route with initial tab
        this.router.navigate([{
            outlets: {
                'popup': ['inventory-details-main',  { initialTab: initialTab }]
            }
        }], { queryParams: { gid: gid } , onSameUrlNavigation: 'reload', queryParamsHandling: 'merge' }).then(() => {
            // Initialize and show Bootstrap modal
            const modalElement = document.getElementById('routerModal');
            if (modalElement) {
                // Set z-index before initializing the modal
                modalElement.style.zIndex = '1000000'; // or any other value you need
                const backdropElement = document.querySelector('.modal-backdrop');
                if (backdropElement) {
                    (backdropElement as HTMLElement).style.zIndex = '999950';
                }

                this.modal = new Modal(modalElement, {
                    keyboard: true,
                    backdrop: 'static',  // Prevent closing by clicking outside
                });
                this.modal.show();

                // Handle modal closing
                modalElement.addEventListener('hidden.bs.modal', () => {
                    this.router.navigate([{ outlets: { popup: null, modalContent: null } }], { queryParamsHandling: 'preserve' });
                    // Reset the backdrop zindex
                    const backdropElement = document.querySelector('.modal-backdrop');
                    if (backdropElement) {
                        (backdropElement as HTMLElement).style.zIndex = '';
                    }
                });
            }
        });
    }

    close() {
        if (this.modal) {
            this.modal.hide();
        }
    }
}
